// version-check.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private versionKey = 'app_version';

  constructor(
    private http: HttpClient,
    private modal: NzModalService
  ) {}

  verificarVersao(): void {
    this.http.get<{ version: string }>('/assets/version.json', { headers: { 'Cache-Control': 'no-cache' } })
      .subscribe({
        next: (data) => {
          const novaVersao = data.version;
          const versaoLocal = localStorage.getItem(this.versionKey);

          if (!versaoLocal) {
            localStorage.setItem(this.versionKey, novaVersao);
          } else if (versaoLocal !== novaVersao) {
            this.modal.confirm({
                nzTitle: 'Nova versão disponível',
                nzContent: `
                  Uma nova versão do sistema (${novaVersao}) foi publicada.
                  Clique em "Atualizar agora" para recarregar a página com a nova versão.`,
                nzOkText: 'Atualizar agora',
                nzCancelText: null,
                nzClosable: false,
                nzMaskClosable: false,
                nzOnOk: () => {
                  localStorage.setItem(this.versionKey, novaVersao);
                  window.location.href = window.location.origin + '?v=' + new Date().getTime();
                }
              });
              
          }
        },
        error: () => {
          console.warn('Não foi possível buscar a versão do sistema.');
        }
      });
  }
}
